import React, { useState, useContext,useEffect } from "react";
import { Link } from "react-router-dom";
import MenuIcon from "../assets/icons/headerIcons/menu.svg"; // Menu icon
import WhatsAppIcon from "../assets/icons/headerIcons/whatsapp.svg"; // WhatsApp icon
import LogoIcon from "../assets/icons/headerIcons/shopName.svg"; // Path to the logo
import LogoPic from "../assets/images/Logo.png";
import Sidebar from "./sidebar";
import { UserContext } from "../pages/UserContext";
import ShopNameSVG from "./ShopNameSVG";

const Header = () => {
  const { user } = useContext(UserContext); // Get user from UserContext
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const [settings, setSettings] = useState({
    shopName: "Shop Name",
    shopLogo: "",
    whatsappNumber: "",
  });
   const [isLoaded, setIsLoaded] = useState(false);
   const logoUrl = settings.shopLogo;

  // Fetch shop details from API
  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/settings`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data) {
          setSettings({
            shopName: data.shop_name || "Shop Name",
            shopLogo: data.logo_white || "/assets/images/default-logo.png", // Default logo fallback
            whatsappNumber: data.whatsapp_number || "",
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching settings:", error);
      });
  }, []);

  const toggleSidebar = () => setSidebarOpen(!isSidebarOpen);

  return (
    <>
      <header className="fixed top-0 left-0 w-full bg-white px-4 py-1 shadow-md z-10 flex items-center justify-between md:px-6 h-14">
        {/* Menu Icon - Visible only on mobile */}
        <button onClick={toggleSidebar} className="text-gray-700">
          <img
            src={MenuIcon}
            alt="Menu Icon"
            className="w-5 h-6 object-contain"
          />
        </button>

        {/* Logo Section */}
        <Link to="/">
          <div className="flex items-center justify-center md:justify-start flex-1 ml-2 md:ml-0">
            {!isLoaded && (
        <img
          src="/assets/images/transparent.png"
          alt="Placeholder"
          className="h-10 absolute inset-0"
        />
      )}

      {/* Actual shop logo image */}
      {logoUrl && (
        <img
          src={logoUrl}
          alt="Shop Logo"
          className="h-10"
          style={{ visibility: isLoaded ? "visible" : "hidden" }}
          onLoad={() => setIsLoaded(true)}
          onError={() => setIsLoaded(true)}
        />
      )}
            <div className="mt-1 ml-1">
              {/* <span className="text-xl font-semibold font-TenorSans-Regular">{settings.shopName}</span> */}
              {/* <img src={LogoIcon} alt="Shop Name" className="h-10 translate-y-1" /> */}
              <ShopNameSVG shopName={settings.shopName} colour="black" />
            </div>
          </div>
        </Link>

        {/* WhatsApp Icon */}
      {/* WhatsApp Icon */}
<button className="text-green-500">
  <a
    href={
      /Android|iPhone/i.test(navigator.userAgent)
        ? `whatsapp://send?phone=${settings.whatsappNumber}&text=Hello,%20I'm%20interested%20in%20your%20products!`
        : `https://wa.me/${settings.whatsappNumber}?text=Hello,%20I'm%20interested%20in%20your%20products!`
    }
    target="_blank"
    rel="noopener noreferrer"
    className="text-green-500"
  >
    <img src={WhatsAppIcon} alt="WhatsApp Icon" className="h-6 w-6" />
  </a>
</button>

      </header>

      {/* Sidebar Component */}
      <Sidebar isOpen={isSidebarOpen} onClose={toggleSidebar} userName={user?.name || "User"} />
    </>
  );
};

export default Header;